
import html2pdf from "html2pdf.js";

export const fillTemplate = (html, data) => {
  let filled = html;
  Object.keys(data).forEach((key) => {
    const regex = new RegExp(`{{${key}}}`, "g");
    filled = filled.replace(regex, data[key] ?? "");
  });
  return filled;
};

// export const loadTemplate = async (docType, previewData) => {
//   const res = await fetch(`/templates/${docType}.html`);
//   const html = await res.text();
//   return fillTemplate(html, previewData);
// };
export const loadTemplate = async (docType, previewData) => {
  const res = await fetch(`/templates/${docType}.html`);
  let html = await res.text();

  // 1️⃣ Remove whole label <p> lines by label name
  const removeLabels = [
    "Date of Birth",
    "Phone",
    "Status",
    "Achievements",
    "Remarks",
  ];

  removeLabels.forEach((label) => {
    const regex = new RegExp(
      `<p[^>]*>\\s*<strong>${label}:<\\/strong>.*?<\\/p>`,
      "gis"
    );
    html = html.replace(regex, "");
  });

  // 2️⃣ Replace placeholders directly
  html = html
    .replace(/{{dob}}/gi, "")
    .replace(/{{status}}/gi, "")
    .replace(/{{achievements}}/gi, "")
    .replace(/{{remarks}}/gi, "")
    .replace(/{{workerPhone}}/gi, "")
    .replace(/{{workerEmail}}/gi, previewData.companyEmail || "");

  // 3️⃣ Clean up any empty <p> tags left behind
  html = html.replace(/<p>\s*<\/p>/g, "");

  // 4️⃣ Fix malformed logo URL if needed
  if (
    previewData.companyLogo &&
    previewData.companyLogo.startsWith("/uploads/logos/https")
  ) {
    previewData.companyLogo = previewData.companyLogo.replace(
      "/uploads/logos/",
      ""
    );
  }

  return fillTemplate(html, previewData);
};




export const generatePDF = async (
  filledHtml,
  filename = "document.pdf",
  returnBlob = false
) => {
  const container = document.createElement("div");
  container.innerHTML = filledHtml;
  document.body.appendChild(container);

  const opt = {
    margin: 10,
    filename,
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  };

  const pdfWorker = html2pdf().set(opt).from(container);

  let blob = null;

  if (returnBlob) {
    // Use html2canvas + jsPDF directly under the hood (no save trigger)
    const pdf = await pdfWorker.outputPdf("blob"); // this ONLY returns a blob
    blob = new Blob([pdf], { type: "application/pdf" });
  } else {
    // Only here it will actually download
    await pdfWorker.save();
  }

  document.body.removeChild(container);
  return blob;
};
